import script from "./LoginButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginButton.vue?vue&type=script&setup=true&lang=js"

import "./LoginButton.vue?vue&type=style&index=0&id=b4d6503e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4d6503e"]])

export default __exports__